module.exports = __webpack_public_path__ + "static/media/8_The PIER-2 ART CENTER - Kaohsiung.057370a6.jpg";